module.exports = __webpack_public_path__ + "logo-robo.png?124b6b40f567f6d688adb984b4e4b234";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logo-robo.png
// module id = 19
// module chunks = 0